<template>
  <div
    id="assign-ticket-modal"
    ref="modal"
    class="modal fade sp-modal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="assign-ticket-title"
    aria-hidden="true"
  >
    <div class="modal-dialog" role="document">
      <form class="modal-content" @submit.prevent="submit">
        <div class="modal-header">
          <div>
            <h5 id="assign-ticket-title" class="modal-title">
              Assign {{ tickets.length }} {{ tickets.length === 1 ? "ticket" : "tickets" }}
            </h5>
            <p class="sp-modal-subtitle">
              They're notified and can work {{ tickets.length === 1 ? "it" : "them" }} from their own account.
            </p>
          </div>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>

        <div class="modal-body">
          <ul class="sp-close-list">
            <li v-for="ticket in tickets" :key="ticket.id">
              <strong>#{{ ticket.id }}</strong>
              <span>{{ ticket.type }}</span>
              <span v-if="ticket.assigned_name" class="sp-sub">· with {{ ticket.assigned_name }}</span>
            </li>
          </ul>

          <div class="sp-label">Assign to</div>
          <PersonPicker v-if="shown" v-model="person" :current-assignee-id="singleAssigneeId" />

          <div class="form-group mt-3 mb-0">
            <label for="assign-ticket-note" class="sp-label">Note for them (optional)</label>
            <textarea
              id="assign-ticket-note"
              v-model="note"
              class="form-control"
              rows="2"
              maxlength="500"
              placeholder="e.g. what's been tried so far"
            ></textarea>
            <small class="form-text text-muted">
              The requesters are told who is handling their tickets.
            </small>
          </div>
        </div>

        <div class="modal-footer">
          <button type="button" class="btn btn-light" data-dismiss="modal">Cancel</button>
          <button type="submit" class="btn btn-primary" :disabled="submitting || !person">
            <span v-if="submitting" class="spinner-border spinner-border-sm mr-1"></span>
            {{ person ? `Assign to ${firstName(person)}` : "Assign" }}
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import PersonPicker from "./PersonPicker.vue";
import { errorMessage } from "../../supportOptions";

/** Assign the selected tickets to one employee. */
export default {
  name: "AssignTicketModal",
  components: { PersonPicker },
  data() {
    return { tickets: [], person: null, note: "", submitting: false, shown: false };
  },
  computed: {
    // With one ticket, its current assignee can't be picked again.
    singleAssigneeId() {
      const only = this.tickets.length === 1 ? this.tickets[0] : null;
      // A new ticket waiting for a technician can go to anyone, the desk included.
      return only && !only.needs_assignment ? Number(only.assigned_to) || null : null;
    },
  },
  mounted() {
    $(this.$refs.modal).on("hidden.bs.modal", (event) => {
      if (event.target === this.$refs.modal) this.shown = false;
    });
  },
  beforeDestroy() {
    $(this.$refs.modal).off("hidden.bs.modal").modal("hide");
  },
  methods: {
    firstName(person) {
      return String(person.name || "").split(" ")[0] || "them";
    },
    open(tickets) {
      this.tickets = (tickets || []).filter((ticket) => ticket.status !== "Closed");
      if (!this.tickets.length) {
        toastr.info("Closed tickets can't be assigned. Reopen them first.", "Nothing to assign");
        return;
      }
      this.person = null;
      this.note = "";
      this.shown = true; // the picker loads people when it appears
      $(this.$refs.modal).modal("show");
    },
    submit() {
      if (this.submitting || !this.person) return;
      this.submitting = true;
      axios
        .post("api/support/tickets/assign", {
          ids: this.tickets.map((ticket) => ticket.id),
          user_id: this.person.id,
          note: this.note.trim(),
        })
        .then((res) => {
          const skipped = this.tickets.length - (res.data.assigned || 0);
          if (skipped) toastr.warning(res.data.message, "Some tickets were skipped");
          else toastr.success(res.data.message, "Assigned");
          this.$emit("assigned");
          $(this.$refs.modal).modal("hide");
        })
        .catch((err) => {
          toastr.error(errorMessage(err), "Not assigned");
        })
        .finally(() => {
          this.submitting = false;
        });
    },
  },
};
</script>
